import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import { CARRIER_LANES } from './actions';
import { EXCLUDE_LANES_LABEL } from '../lanes-list/constants';

export const reducers = createReducer(
	initialState,
	on(CARRIER_LANES.LANES_LIST.GET, (state, action: any) => ({
		...state,
		loading: true,
	})),
	on(CARRIER_LANES.LANES_LIST.FAILURE, (state, action: any) => ({
		...state,
		loading: false,
		error: action.payload.message,
	})),
	on(CARRIER_LANES.LANES_LIST.SUCCESS, (state, action: any) => ({
		...state,
		loading: false,
		lanesList: action.data,
		total: action.numberOfResults,
	})),

	// remove deleted lanes
	on(
		CARRIER_LANES.DELETE_LANES.SUCCESS,
		(state, action: { carrierLanesList: any; carrierLaneIds: string[] }) => ({
			...state,
			lanesList: state.lanesList.filter(
				(lane) => !lane.carrierLaneIds?.some((id: string) => action.carrierLaneIds.includes(id))
			),
		})
	),

	// updates on exclude / include lanes
	on(
		CARRIER_LANES.EXCLUDE_LANES.SUCCESS,
		(state, action: { carrierLaneIds: string[]; excluded: boolean }) => {
			const target = new Set(action.carrierLaneIds.map(String));

			return {
				...state,
				lanesList: state.lanesList.map((lane) => {
					const memberIds = (lane.carrierLaneIds ?? []).map(String);
					const intersects = memberIds.some((id) => target.has(id));
					return intersects
						? {
								...lane,
								excludedLabel: action.excluded ? EXCLUDE_LANES_LABEL.YES : EXCLUDE_LANES_LABEL.NO,
							}
						: lane;
				}),
			};
		}
	),

	// updates on broker account map
	on(CARRIER_LANES.DELETE_BROKER_ACCOUNT_MAP.SUCCESS, (state, action: { carrierLanes: any[] }) => ({
		...state,
		lanesList: applyAggregates(state.lanesList, action.carrierLanes || []),
		loading: false,
		error: null,
	})),

	on(CARRIER_LANES.ASSIGN_TO_ACCOUNT.SUCCESS, (state, action: { carrierLanes: any[] }) => ({
		...state,
		lanesList: applyAggregates(state.lanesList, action.carrierLanes || []),
		loading: false,
		error: null,
	})),

	on(CARRIER_LANES.RESET_STATE, (state) => ({
		...initialState,
	})),

	// set data
	on(CARRIER_LANES.SET.FILTER_LIST, (state, action: { filtersList: any[] }) => ({
		...state,
		filters: action.filtersList,
	})),
	on(CARRIER_LANES.SET.SORT_LIST, (state, action: { sortList: any[] }) => ({
		...state,
		sort: action.sortList,
	})),
	on(CARRIER_LANES.SET.PAGE, (state, { currentPage }) => ({
		...state,
		currentPage,
	})),
	on(CARRIER_LANES.SET.PAGE_SIZE, (state, { pageSize }) => ({
		...state,
		pageSize,
	})),

	on(CARRIER_LANES.CONFIRM_ACCOUNT, (state, { pageSize }) => ({
		...state,
	}))
);

const matchByOverlap = (aIds?: string[], bIds?: string[]) =>
	Array.isArray(aIds) && Array.isArray(bIds) && aIds.some((id) => bIds.includes(id));

const applyAggregates = (stateRows: any[], updates: any[]) =>
	stateRows.map((row) => {
		const upd = updates.find((u) => matchByOverlap(row.carrierLaneIds, u.carrierLaneIds));
		if (!upd) return row;

		return {
			...row,
			// single source of truth: replace with server’s view
			brokerAccountMaps: Array.isArray(upd.brokerAccountMaps) ? upd.brokerAccountMaps : [],
		};
	});
